import React, {ChangeEvent, useState, useEffect} from 'react';
import { InputProps } from "./Input.types";
import { VALIDATE_DISTANCE } from "app/queries/ValidateLocation";
import './input.scss'
// @ts-ignore
import Autocomplete from 'react-google-autocomplete'
import {useMutation} from "@apollo/react-hooks";
import {ExecutionResult} from "graphql";
import {ValidateLocationInterface} from "app/queries/ValidateLocation";
import {toast} from "react-toastify";
import NumberFormat from 'react-number-format';

export function Input(props: InputProps) {
  const {
    showLabel = true,
    label,
    placeholder = '',
    tooltip,
    type = 'text',
    className = '',
    fieldName, col = '12',
    validationRule,
    required = true,
    flagErrors = false,
    errorMessage,
    value
  } = props

  const [state, setState] = useState<{ validInput: boolean, validLocation: boolean}>({validInput: !required, validLocation: true})
  const [ validateAddress ] = useMutation(VALIDATE_DISTANCE);

  // hard coding this cause dont got time for reusability
  const [allow, setAllow] = useState<boolean>(!!value)

  function updateFormData(text: string | number | boolean, validOverride: boolean = false) {
    let validInput: boolean = checkValid(text)
    if(validOverride) validInput = false
    if(type === 'number' && text < 0) text = 0;

    setState({validInput, validLocation: !validOverride});
    props.updateFormData(fieldName, text, validInput)
  }

  function checkValid(text: string | number | boolean): boolean {
    let validInput: boolean;
    if(required) validInput = String(text).length > 0
    else validInput = true
    if(validationRule) validInput = validationRule(text)
    return validInput;
  }

  async function checkLocation(text: string | number) {
    try{
      const response: ExecutionResult<ValidateLocationInterface> = await validateAddress({
        variables: {
          address: text,
        }
      });
      if(response?.data?.validateAddress?.success) {
        updateFormData(text);
      } else {
        updateFormData(text, true);
      }

    } catch {
      toast.warn('Invalid Data')
    }
  }

  const standardInput: React.ReactNode = <input
    type={type}
    className={`form-control ${className}`}
    id={label} aria-describedby={`${label}Help`}
    placeholder={placeholder}
    value={value}
    onChange={(e) => updateFormData(e.target.value)}
  />;


  const phoneInput = <NumberFormat
      format="+1 (###) ###-####"
      mask="_"
      value={String(value)}
      onChange={(e) => updateFormData(e.target.value)}
  />;

  async function handleChangeCheck(setting: boolean) {
    await setAllow(!setting);
    updateFormData(!setting)
  }

  const checkboxInput = <input type="checkbox" checked={allow} onChange={(e) => {handleChangeCheck(allow)}} />

  const placeInput = <Autocomplete
      types={''}
      componentRestrictions={{country: "us"}}
      onChange={(e: ChangeEvent<HTMLInputElement>) => updateFormData(e.target.value)}
      bounds={[{lat: 38.1507742, lng: -92.7951027}, {lat: 38.2760732, lng: -92.6039197}]}
      onBlur={(e: ChangeEvent<HTMLInputElement>) => updateFormData(e.target.value)}
      onPlaceSelected = {(place: any) => checkLocation(place.formatted_address)}
      placeholder=''
      className={!state.validLocation && 'text-danger'}
  />;

  return (
      <div className={`form-group col-12 ${col} ${(state.validInput && props.value !== '') && 'valid text-primary'} ${flagErrors && !state.validInput && 'text-danger'}`}>
        {showLabel &&
        <label className='form-label' htmlFor={label}>{label}{required && '*'}</label>
        }
        {
          type === 'tel' ? phoneInput
          : type === 'place' ? placeInput
              : type === 'checkbox' ? checkboxInput
          : standardInput
        }
        {
          !state.validLocation
            ? <small id={`${label}Help`} className="form-text text-muted">*This location is not in the service area, however do offer private charters Sunday-Thursday up to the 26 mile marker</small>
              : tooltip && <small id={`${label}Help`} className="form-text text-muted">{tooltip}</small>
        }
        {flagErrors && <small id={`${label}Help`} className="form-text text-muted">{errorMessage ?? 'This field is invalid'}</small>}
      </div>
  )
}
